import { Grid2 } from "@mui/material";
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { observer } from "mobx-react";
import { useStores } from "../../../../use-stores";
import { EmployeeRoles } from "../../../../../../models/Employees/EmployeeRoles";
import CustomerHeading from "../../../components/projects/projectDetails/CustomerHeading";
import PermissionBlockLabel from "../../../../../../views/components/common/pop-up/PermissionBlockLabel ";
import AppButton from "../../../../../../views/components/common/buttons/AppButton";
import UniversalShipments from "../../UniversalShipments";

const DISPATCH_PRESERVE_QUERY_KEYS = ["tab_index"];

const DispatchOps = () => {
  const { userStore, orderStore, projectInventoryOpsStore } = useStores();
  const navigate = useNavigate();
  const { "project-id": projectId } = useParams();
  const orderId = Number(projectId);

  useEffect(() => {
    if (!orderId) return;
    if (
      !orderStore.orderBasicDetails ||
      orderStore.orderBasicDetails.id !== orderId
    ) {
      orderStore.getOrderBasicDetails(orderId).catch(() => {});
    }
  }, [orderId, orderStore]);

  return (
    <Grid2 size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
      {userStore.hasPermission(EmployeeRoles.VIEW_ORDER) ? (
        <>
          {orderId ? (
            <UniversalShipments
              key={orderId}
              lockedOrderId={orderId}
              preserveQueryKeys={DISPATCH_PRESERVE_QUERY_KEYS}
              hidePageHeader
              defaultStatusTab="all"
              viewPermission={EmployeeRoles.VIEW_ORDER}
              compactLayout
              simpleSearchOnly
              pageHeaderStart={
                <CustomerHeading
                  label={orderStore.orderBasicDetails?.label || ""}
                  orderId={Number(orderId)}
                  moduleName="Dispatch Ops"
                  brandName={orderStore.orderBasicDetails?.customer?.name || ""}
                  progressValue={
                    projectInventoryOpsStore.inventoryRequestBody
                      .total_progress || 0
                  }
                />
              }
              headerTrailingActions={
                <AppButton
                  variant="secondary"
                  label="Universal Shipments"
                  onClick={() => {
                    navigate("/inventory/shipments");
                  }}
                />
              }
            />
          ) : null}
        </>
      ) : (
        <PermissionBlockLabel />
      )}
    </Grid2>
  );
};

export default observer(DispatchOps);
